<div class="widget" style="max-height: fit-content;flex: none;">
  <div class="header">
    <div class="title">
      <span>Arming Mode</span>
      <ng-container *ngIf="site.is_partition_enabled; else armingSourceLabel">
        <span class="tag-label ml-4">Partition System</span>
      </ng-container>
      <ng-template #armingSourceLabel>
        <span class="tag-label ml-4" *ngIf="site.arming_source === 1 || site.arming_source === 2">Alarm Panel Pairing</span>
        <span class="tag-label ml-4" *ngIf="site.arming_source === 3">CHeKT Video Security System</span>
        <span class="tag-label ml-4" *ngIf="site.arming_source === 4">ADC Based Arming</span>
        <span class="tag-label ml-4" *ngIf="site.arming_source === 5">OE Based Arming</span>
      </ng-template>
    </div>
    <div class="btn-area" *ngIf="site.is_activated">
      <div class="button button-white"
        [class.disabled]="isChangeArmingStatusDisabled()"
        (click)="changeArmingStatus()"
        *ngIf="canChangeArmingStatus() && !site.is_partition_enabled"
      >
        <div class="btn-inner">{{toArmingStatus}} Site</div>
      </div>
      <div class="button button-white" (click)="openEditArming()" *ngIf="site.is_partition_enabled" [class.disabled]="isOESite() && !isVirtualPanelOESite()">
        <div class="btn-inner">Arming Control</div>
      </div>
    </div>
  </div>
  <div class="body arming-status" [ngClass]="armingClass" [ngSwitch]="displayArmingStatus" [style.overflow-y]="isExternalArmingSource() ? 'unset' : null" *ngIf="showOriginalArmingStatus()">
    <div class="external-portal" *ngSwitchCase="'UNAVAILABLE'">
      <img class="external-thumbnail" *ngIf="site.registered_by === 'ADC'" src="/assets/logo/adc_logo.png"/>
      <img class="external-thumbnail" *ngIf="site.registered_by === 'OE'" src="/assets/logo/oe_logo.png"/>
      <span>UNAVAILABLE</span>
    </div>
    <div class="arming-content" *ngSwitchCase="'NO VCP'">
      <span>{{displayArmingStatus}}</span>
    </div>
    <div class="arming-content" *ngSwitchCase="'armed'">
      <comp-icon class="icon" [icon]="'armed'" [color]="'#ff7f16'" [size]="24"></comp-icon>
      <span>{{displayArmingStatus}}</span>
    </div>
    <div class="arming-content" *ngSwitchCase="'disarmed'">
      <comp-icon class="icon" [icon]="'disarmed'" [color]="'#1ea675'" [size]="24"></comp-icon>
      <span>{{displayArmingStatus}}</span>
    </div>
    <div class="arming-content" *ngSwitchCase="'partially armed'">
      <comp-icon class="icon" [icon]="'armed'" [color]="'#f5a623'" [size]="24"></comp-icon>
      <comp-icon class="icon" [icon]="'disarmed'" [color]="'#f5a623'" [size]="24"></comp-icon>
      <span>{{displayArmingStatus}}</span>
    </div>
    <div class="arming-content" *ngSwitchCase="'LOADING...'"><span>{{displayArmingStatus}}</span></div>
    <div class="arming-content" *ngSwitchCase="'NO PERMISSION'"><span>{{displayArmingStatus}}</span></div>

    <div class="absolute-right-bottom" *ngIf="lastArmingTime && !isExternalArmingSource()">
      <span class="time-label">Site
        <span style="text-transform: capitalize; margin-left:4px">{{displayArmingStatus}}</span> on {{lastArmingTime}}
      </span>
    </div>
    <div class="absolute-right-bottom v-center" *ngIf="lastArmingTime && isExternalArmingSource() && displayArmingStatus != 'UNAVAILABLE'" style="gap: 4px">
      <div class="time-label">Site
        <span style="text-transform: capitalize; margin-left:4px">{{displayArmingStatus}}</span> as of {{lastArmingTime}}
      </div>
      <div class="tooltip-content v-center">
        <comp-icon class="pointer" [icon]="'info'" [size]="14" [color]="'hsla(216, 13%, 58%, 0.6)'"></comp-icon>
        <div class="tooltip" style="padding: 15px; display: flex; justify-content: center; align-items: center">
          <div class="tooltip-item" style="font-weight: normal;">This system is {{displayArmingStatus}} based on the last known status of the {{site.registered_by}} alarm panel.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="body arming-status partition-view" *ngIf="showPartitionView()" (click)="openPartitionArming()">
    <div class="partition-armed" *ngIf="getArmedPartitionsCount() > 0" [style.width.%]="getArmedPercentage()">
      <div class="arming-content">
        <comp-icon class="icon" [icon]="'armed'" [color]="'#ff7f16'" [size]="24"></comp-icon>
        <span class="partition-label-full">{{getArmedPartitionsCount()}} ARMED</span>
        <span class="partition-label-short">{{getArmedPartitionsCount()}}</span>
      </div>
    </div>
    <div class="partition-disarmed" *ngIf="getDisarmedPartitionsCount() > 0" [style.width.%]="getDisarmedPercentage()">
      <div class="arming-content">
        <comp-icon class="icon" [icon]="'disarmed'" [color]="'#1ea675'" [size]="24"></comp-icon>
        <span class="partition-label-full">{{getDisarmedPartitionsCount()}} DISARMED</span>
        <span class="partition-label-short">{{getDisarmedPartitionsCount()}}</span>
      </div>
    </div>
    <div class="partition-unknown" *ngIf="getUnknownPartitionsCount() > 0" [style.width.%]="getUnknownPercentage()">
      <div class="arming-content">
        <comp-icon class="icon" [icon]="'unknown_arming'" [color]="'#555555'" [size]="24"></comp-icon>
        <span class="partition-label-full">{{getUnknownPartitionsCount()}} UNKNOWN</span>
        <span class="partition-label-short">{{getUnknownPartitionsCount()}}</span>
      </div>
    </div>
    <div class="partition-last-arming" *ngIf="lastArmingTime">
      <span class="time-label">Last Arming Action on {{lastArmingTime}}</span>
    </div>
  </div>

  <div class="body arming-status none" *ngIf="showNoActivePartition()">
    <div class="arming-content">
      <span>NO CAMERAS IN PARTITIONS</span>
      <div class="tooltip-content v-center" style="margin-left: 6px;">
        <comp-icon class="pointer" [icon]="'info'" [size]="14" [color]="'hsla(216, 13%, 58%, 0.6)'"></comp-icon>
        <div class="tooltip" style="padding: 15px; display: flex; justify-content: center; align-items: center">
          <div class="tooltip-item" style="font-weight: normal;">Only partitions with cameras assigned can be controlled from this widget. Assign cameras to a partition to enable arming control.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="body arming-status" *ngIf="!site.is_activated">Deactivated</div>
</div>

<dealer-partition-arming [modal]="m_partition_arming" [active]="m_partition_arming.is_active" [site]="site" [me]="me" [partitions]="partitions" (partitionUpdated)="partitionUpdated($event)"></dealer-partition-arming>
